import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { EmailAuditContainerComponent } from './email-audit-container';
import { EmailAuditPresenter } from './email-audit-presenter';
import { EmailAuditRoute } from './email-audit.route';

@NgModule({
    declarations: [EmailAuditContainerComponent, EmailAuditPresenter],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [EmailAuditRoute]
        })
    ]
})
export class EmailAuditModule {}
